import { Card, Flex, Radio, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { CustomParagraph } from "../../../components";
import optionsIcon from "../../../assets/images/options.svg";
import { useSelector } from "react-redux";
import { GetShipments } from "../../../api's/shipment";
import { useToken } from "../../../common/helper";
import { useNavigate } from "react-router-dom";

const AnalyticsData = ({
  title,
  data,
  value,
  change,
  fromDate,
  setModalOpen,
  setSelectedMetricData,
  isShipments,
}) => {
  const { token, removeToken } = useToken();
  const navigate = useNavigate();

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  // const getFormattedChange = (value) => {
  //   const num = parseFloat(value);
  //   if (isNaN(num)) return '---';
  //   return num > 0 ? `+${num}` : `${num}`;
  // };

  function getFormattedChange(variance) {
    if (variance === null || variance === undefined || variance === "")
      return "";

    let isPercent = false;

    // Convert to string and trim whitespace
    let strValue = String(variance).trim();

    // Check for % and remove it for parsing
    if (strValue.includes("%")) {
      isPercent = true;
      strValue = strValue.replace("%", "");
    }

    // Try parsing the numeric value
    const num = parseFloat(strValue);
    if (isNaN(num)) return variance; // return original if not a valid number

    // Format with + if positive
    const formatted = (num > 0 ? `+${num}` : `${num}`) + (isPercent ? "%" : "");

    return formatted;
  }

  const getChangeColor = (value) => {
    if (value === null || value === undefined || value === "") return "#5E5E5E";

    const num = parseFloat(String(value).replace("%", "").trim());
    if (isNaN(num)) return "#5E5E5E";

    return num >= 0 ? "#0E8345" : "#DE1135";
  };

  const mainMenu = useSelector((state) => state.menu.items);
  const homePermissions = mainMenu?.find(
    (item) => item?.name.toLowerCase() == "home"
  );



  return (
    <>
      <Flex gap={8} align="center" justify="space-between">
        <CustomParagraph
          text={title}
          fontSize={12}
          fontWeight={600}
          lineHeight={"16px"}
          marginBottom={3}
          color={"#000"}
        />
        {homePermissions?.permissions?.is_create ||
        homePermissions?.permissions?.is_update ? (
          <>
            {isShipments?.length > 0 && (
              <Tooltip placement="top" title={"Add/edit target"} arrow={true}>
                <img
                  onClick={() => {
                    setModalOpen(true);
                    setSelectedMetricData({ ...data, title});
                  }}
                  src={optionsIcon}
                  alt=""
                  className="cursor-pointer"
                />
              </Tooltip>
            )}
          </>
        ) : null}
      </Flex>

      <CustomParagraph
        text={value || "---"}
        fontSize={20}
        fontWeight={700}
        lineHeight={"28px"}
        marginBottom={2}
        color={"#000"}
      />

      <Flex gap={8} align="center">
        <CustomParagraph
          text={getFormattedChange(change)}
          fontSize={12}
          fontWeight={400}
          lineHeight={"20px"}
          marginBottom={0}
          whiteSpace={"nowrap"}
          color={getChangeColor(change)}
        />

        <CustomParagraph
          text={fromDate || ""}
          fontSize={12}
          fontWeight={400}
          lineHeight={"20px"}
          marginBottom={0}
          color={"#5E5E5E"}
        />
      </Flex>
    </>
  );
};

export default AnalyticsData;
